import React from "react";
import "./Footer.css";

const Footer = () => {
  return (
    <div className="footer-bottom">
      © All Rights Reserved | AavryaaFabHub | Developed by VrOne Technologies
    </div>
  );
};

export default Footer;
